export enum TrackingEventName {
  AnalyseListRowsNumberUpdate = 'AnalyseListPaginationSelector',
  AnalyseListNextPage = 'AnalyseListNextPage',
  AnalyseListExport = 'AnalyseListExport',
  AnalyseEditRules = 'AnalyseEditRules',
  AnalyseLockCandidate = 'AnalyseLockCandidate',
  AnalysisEditRulesConversationRuleClick = 'AnalysisEditRulesConversationRuleClick',
  AnalysisCreateConversationRuleClick = 'AnalysisCreateConversationRuleClick',
  AnalyseCreate = 'AnalyseCreate',
  RulesetCreate = 'RulesetCreate',
  AnalyseDashboardShare = 'AnalyseDashboardShare',
  AnalyseDashboardExport = 'AnalyseDashboardExport',
  RulesetAddJob = 'RulesetAddJob',
  Help = 'Help',
  Profile = 'Profile',
  Settings = 'Settings',
  CampaignsListExport = 'CampaignsListExport',
  CampaignsListCreateManually = 'CampaignsListCreateManually',
  CampaignsListCreateForAutomation = 'CampaignsListCreateForAutomation',
  CampaignsListCreateFromCandidatesList = 'CampaignsListCreateFromCandidatesList',
  CampaignsListCreateForRole = 'CampaignsListCreateForRole',
  CampaignsListNeedsReviewFilter = 'CampaignsListNeedsReviewFilter',
  CampaignsListStatusFilter = 'CampaignsListStatusFilter',
  CampaignsListRowsNumberUpdate = 'CampaignsListRowsNumberUpdate',
  CampaignsListNextPage = 'CampaignsListNextPage',
  CampaignsListActionDuplicate = 'CampaignsListActionDuplicate',
  CampaignsListActionArchive = 'CampaignsListActionArchive',
  CampaignsListActionLaunch = 'CampaignsListActionLaunch',
  CampaignsCreationLaunchSendNow = 'CampaignsCreationLaunchSendNow',
  CampaignsCreationLaunchSchedule = 'CampaignsCreationLaunchSchedule',
  CampaignsCreationOptionalQuestionsPreviewRequirements = 'CampaignsCreationOptionalQuestionsPreviewRequirements',
  CampaignDashboardSummary = 'CampaignDashboardSummary',
  CampaignDashboardAddCandidates = 'CampaignDashboardAddCandidates',
  CampaignDashboardActionNotifyTeam = 'CampaignDashboardActionNotifyTeam',
  CampaignDashboardActionExport = 'CampaignDashboardActionExport',
  CampaignDashboardFilterConversationStatus = 'CampaignDashboardFilterConversationStatus',
  CampaignDashboardFilterScreeningStatus = 'CampaignDashboardFilterScreeningStatus',
  CampaignDashboardSortLastActivity = 'CampaignDashboardSortLastActivity',
  CampaignDashboardSortReplies = 'CampaignDashboardSortReplies',
  CampaignDashboardConversationTakeover = 'CampaignDashboardConversationTakeover',
  CampaignDashboardConversationHandover = 'CampaignDashboardConversationHandover',
  CampaignDashboardConversationCandidateDetails = 'CampaignDashboardConversationCandidateDetails',
  CampaignDashboardConversationScreeningSummary = 'CampaignDashboardConversationScreeningSummary',
  CampaignDashboardConversationResponsesSummary = 'CampaignDashboardConversationResponsesSummary',
  CampaignDashboardConversationCopyConversation = 'CampaignDashboardConversationCopyConversation',
  CampaignDashboardConversationRestart = 'CampaignDashboardConversationRestart',
  CampaignDashboardConversationNext = 'CampaignDashboardConversationNext',
  CampaignDashboardConversationPrevious = 'CampaignDashboardConversationPrevious',
  CampaignDashboardConversationResolve = 'CampaignDashboardConversationResolve',
  CampaignDashboardAutomation = 'CampaignDashboardAutomation',
  CampaignAutomationCreate = 'CampaignAutomationCreate',
  CampaignDashboardConversationOptionalSummary = 'CampaignDashboardConversationOptionalSummary',
  CampaignDashboardListSortingScore = 'CampaignDashboardListSortingScore',
  CampaignsCreationBack = 'CampaignsCreationBack',
  ProfileCorrespondenceEmailTypeChange = 'ProfileCorrespondenceEmailTypeChange',
  CampaignDashboardConversationPlayVoiceNote = 'CampaignDashboardConversationPlayVoiceNote',
  CampaignCsvUploadContactsTemplateDownloaded = 'CampaignCsvUploadContactsTemplateDownloaded',
  CampaignCsvUploadE164formatUrlClicked = 'CampaignCsvUploadE164formatUrlClicked',
  AddToExistingCampaign = 'AddToExistingCampaign',
  AnalyseListInvite = 'AnalyseListInvite',
  AnalyseDashboardSourceFromBlank = 'AnalyseDashboardSourceFromBlank',
  AnalyseDashboardSourceFromMainCTA = 'AnalyseDashboardSourceFromMainCTA',
  AnalyseListFindCandidates = 'AnalyseListFindCandidates',
  SourcingSelectCandidateToInvite = 'SourcingSelectCandidateToInvite',
  CandidateProfileDrawerOpen = 'CandidateProfileDrawerOpen',
  SourcingLinkedInProfileClick = 'SourcingLinkedInProfileClick',
  SourcingInviteChooseApplicationUrl = 'SourcingInviteChooseApplicationUrl',
  SourcingSuccessFindMoreCandidates = 'SourcingSuccessFindMoreCandidates',
  AnalyseDashboardInvitedTabClick = 'AnalyseDashboardInvitedTabClick',
  CampaignCreationChannelAlreadyAppliedOptionsChange = 'CampaignCreationChannelAlreadyAppliedOptionsChange',
  CampaignCreationEngagementTypeChange = 'CampaignCreationEngagementTypeChange'
}
